import { useMemo } from "react";
import { InfiniteData } from "react-query";

import { IPageable } from "@/core/api";

export interface InfiniteFlatDataResultState<R> {
  flatData: R[];
}

export const useInfiniteQueryFlatData = <R>(
  filter?: (record: R) => boolean,
  data?: InfiniteData<IPageable<R[]>>,
): InfiniteFlatDataResultState<R> => {
  const flatData = useMemo(() => {
    if (!data || !data.pages) {
      return [];
    }

    if (!filter) {
      return data.pages.map(page => page.content).flat();
    } else {
      return data.pages
        .map(page => page.content)
        .flat()
        .filter(filter);
    }
  }, [data, filter]);

  return { flatData };
};
